import { Meeting } from '../models/chat';
import { AuthServiceInterface } from './AuthServiceInterface';

export class MeetingUtilService {
    static $inject = ['AuthService'];

    constructor(private authService: AuthServiceInterface) {}

    /**
     * Returns url for meeting topic:
     * - eg. user profile for private conversation
     * - eg. group url for group meeting
     */
    public getMeetingTopicUrl(meeting: Meeting) {
        if (meeting.type === 'community' && meeting.group_id) {
            return `/group/${meeting.group_id}`;
        }

        const partnerId = this.getPrivateMeetingConversationPartnerId(meeting);

        if (meeting.type === 'private' && partnerId) {
            return `/${partnerId}`;
        }

        return '';
    }

    /**
     * Get conversation partner id
     * Works only on private meetings
     * @param meeting
     * @return number|false
     */
    public getPrivateMeetingConversationPartnerId(meeting: Meeting) {
        if (meeting.type !== 'private') {
            return false;
        }

        const currentUserId = this.authService.getUserId();

        const otherUserId: number | undefined = Object.keys(meeting.participants)
            .map((id) => Number(id))
            .find((id) => id !== currentUserId);

        return otherUserId;
    }
}

angular.module('tradersyard').service('MeetingUtilService', MeetingUtilService);
